import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockUsageReportData} from "./stock-usage-report.data";

@Injectable()
export class StockUsageReportModel extends ReportModel<StockUsageReportData> {
    constructor(injector: Injector) {
        super(injector, StockUsageReportData);
    }
}
